"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollLockGeneric = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var React = __importStar(require("react"));
var update = function (target, child, setVisible, onScrollLockPosition, offSet) {
    return function () {
        var targetTop = target.getBoundingClientRect().top;
        var childHeight = child.getBoundingClientRect().height;
        if (onScrollLockPosition === 'bottom') {
            if (targetTop - (offSet !== null && offSet !== void 0 ? offSet : 0) < 0 ||
                targetTop + childHeight + (offSet !== null && offSet !== void 0 ? offSet : 0) > document.documentElement.clientHeight) {
                setVisible('lock-fixed');
            }
            else {
                setVisible('original-position');
            }
        }
        if (onScrollLockPosition === 'top') {
            if (targetTop > (offSet !== null && offSet !== void 0 ? offSet : 0)) {
                setVisible('original-position');
            }
            else {
                setVisible('lock-fixed');
            }
        }
    };
};
var ScrollLockGeneric = function (_a) {
    var _b;
    var children = _a.children, onScrollLockPosition = _a.onScrollLockPosition, _c = _a.offset, offset = _c === void 0 ? 0 : _c;
    var childRef = React.useRef(null);
    var parentRef = React.useRef(null);
    var _d = React.useState('original-position'), lock = _d[0], setLock = _d[1];
    var _e = React.useState(), childWidth = _e[0], setChildWidth = _e[1];
    function getChildRef() {
        var _a;
        return (_a = childRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    }
    function getParentRef() {
        var _a;
        return (_a = parentRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    }
    var handleResize = React.useCallback(function () {
        var _a;
        setChildWidth((_a = getParentRef()) === null || _a === void 0 ? void 0 : _a.width);
    }, []);
    React.useEffect(function () {
        if (parentRef.current) {
            handleResize();
        }
    }, [handleResize]);
    function buildStyle(l) {
        var _a;
        switch (l) {
            case 'lock-fixed':
                return _a = {
                        position: 'fixed'
                    },
                    _a[onScrollLockPosition] = offset,
                    _a;
            case 'original-position':
                return { width: childWidth };
        }
    }
    React.useEffect(function () {
        if (parentRef.current === null || childRef.current === null) {
            return;
        }
        var handler = update(parentRef.current, childRef.current, setLock, onScrollLockPosition, offset);
        handler();
        document.addEventListener('scroll', handler);
        return function () {
            document.removeEventListener('scroll', handler);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [parentRef]);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "scroll-lock-parent", css: (0, react_1.css)({
            height: (_b = getChildRef()) === null || _b === void 0 ? void 0 : _b.height,
        }), ref: parentRef }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "scroll-lock-children", css: (0, react_1.css)(__assign(__assign({}, buildStyle(lock)), { width: childWidth })), ref: childRef }, { children: children })) })));
};
exports.ScrollLockGeneric = ScrollLockGeneric;
//# sourceMappingURL=ScrollLockGeneric.js.map